import avatarIcon from '../../assets/user.svg';
import { CEO_PORTRAIT_URL, cloudinaryTeamImage } from '../../config/cloudinaryTeamImages';

export const TEAM_AVATAR_FALLBACK = avatarIcon;

export let TEAM_MEMBERS = [
  {
    name: 'Jaffar Ali Chaudhary',
    role: 'Founder & CEO',
    image: CEO_PORTRAIT_URL,
    avatarPosition: 'center top',
    featured: true,
    spotlight: true,
  },
  {
    name: 'Jawad Afzal',
    role: 'CTO',
    image: cloudinaryTeamImage('cto'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Amari Fields',
    role: 'Director of CS & Business Development',
    image: cloudinaryTeamImage('amariFields'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Maudood Fareed',
    role: 'Team Lead',
    image: cloudinaryTeamImage('teamLead'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Akhlaq Ahmad',
    role: 'Senior Software Engineer',
    image: cloudinaryTeamImage('akhlaq'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Alishba Aslam',
    role: 'HR Manager',
    image: cloudinaryTeamImage('alishba'),
    avatarPosition: 'center top',
  },
  {
    name: 'Shamaim Ali Rizvi',
    role: 'Senior UI UX Designer',
    image: cloudinaryTeamImage('shamaim'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Wali ullah',
    role: 'Business Development Executive',
    image: cloudinaryTeamImage('businessDev'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Abdullah Anjum',
    role: 'Business Development Executive',
    image: cloudinaryTeamImage('marketingManager'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Maarij Ali',
    role: 'Technical Project Manager',
    image: cloudinaryTeamImage('projectManager'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Ali Raza',
    role: 'Senior Software Engineer',
    image: cloudinaryTeamImage('softwareEngineer3'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Saad Bin Abi Usama',
    role: 'Senior Software Engineer',
    image: cloudinaryTeamImage('softwareEngineer2'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Hamza Mumtaz',
    role: 'UI UX Designer',
    image: cloudinaryTeamImage('uiUxDesigner'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Faizan Ahmed',
    role: 'Associate Software Engineer',
    image: cloudinaryTeamImage('softwareEngineer'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Junaid Qamar',
    role: 'Associate Software Engineer',
    image: cloudinaryTeamImage('junaid'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Talha Bin Faisal',
    role: 'Full Stack AI Developer',
    image: cloudinaryTeamImage('fullstackAi'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Hamad Khan',
    role: 'AI/ML Engineer',
    image: cloudinaryTeamImage('hamadKhan'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Syed Ali Musa Rizvi',
    role: 'AI & Automation Engineer',
    image: 'https://res.cloudinary.com/deelyxcjk/image/upload/v1788809714/Syed_Ali_Musa_Rizvi_szi0od.png',
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Laiba Sheikh',
    role: 'Marketing Head',
    image: cloudinaryTeamImage('laiba'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Hadeed Tarar',
    role: 'Business Development Executive',
    image: cloudinaryTeamImage('hadeedTarar'),
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Zobia Ali',
    role: 'Business Development Executive',
    image: 'https://res.cloudinary.com/deelyxcjk/image/upload/v1786632695/person-1_rxxwtn.png',
    avatarPosition: 'center top',
    featured: true,
  },
  {
    name: 'Abdullah Afzal',
    role: 'Business Development Executive',
    image: 'https://res.cloudinary.com/deelyxcjk/image/upload/v1788809714/Abdullah_Afzal_mxhk99.png',
    avatarPosition: 'center top',
    featured: true,
  },
];

function buildTeamImageUrls() {
  return [
    ...new Set([TEAM_AVATAR_FALLBACK, ...TEAM_MEMBERS.map((m) => m.image)].filter(Boolean)),
  ];
}

/** Unique image URLs for eager browser preload. */
export let TEAM_IMAGE_URLS = buildTeamImageUrls();

export function hydrateTeamMembers(members) {
  if (Array.isArray(members)) {
    TEAM_MEMBERS = members;
    TEAM_IMAGE_URLS = buildTeamImageUrls();
  }
}
